import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-da230b84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }

import { ref } from 'vue';
import stitchedBg from "@activity-business/h5-package-stitchedBg";


export default /*#__PURE__*/_defineComponent({
  __name: 'listBg',
  setup(__props) {

const configBg = {
    domain: DOMAIN.H5_IMAGE_DOMAIN,
    projectName: "202411_PreludeRank",
    bgList: {
        top: { 
            imgName: 'top', 
            height: '3.74rem'
        },
        center: { 
            imgName: 'mid', 
            height: '1.08rem'
        },
        bottom: { 
            imgName: 'btm', 
            height: '1.36rem'
        }
    },
    bgWidth: '7.02rem',
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(stitchedBg), _normalizeProps(_guardReactiveProps(configBg)), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */))
}
}

})